import { SchoolSuggestion } from '../../search/types/typeaheadSuggestions';
import { Svg } from '../../common/Svg';

interface RecurringDonationSchoolCardProps {
    school: SchoolSuggestion,
}

export const RecurringDonationSchoolCard = function ({ school }: RecurringDonationSchoolCardProps) {
    return (
        <div className="school-card">
            <div className="school-location">
                <span className="location"><Svg icon="location" />{school.cityName}, {school.stateCode}</span>
            </div>
            <h3 className="school-name">
                {school.schoolName}
            </h3>
        </div>
    );
};
